import React from 'react';
import classnames from 'classnames';

import { useImageResize } from '../../../hooks/useImageResize';
import { ImageAndTextComponentFragment } from '../../../../graphql.schema';
import { ContentBlock } from '../../ContentBlock/ContentBlock';
import Image from '../../Image';
import * as styles from './image-and-text.module.scss';
type ImageAndTextComponentFragmentProps = ImageAndTextComponentFragment & { hasRTL?: boolean };

export const StrapiImageAndTextComponent: React.FC<ImageAndTextComponentFragmentProps> = (props) => {
  const { imageWrapper, imageStyle } = useImageResize(props?.mandatory_image ?? { url: '' });
  return (
    <div className={classnames(styles.root, { [styles.alternate]: props.shadedBackground })}>
      <div className="container">
        <div ref={imageWrapper} className={classnames(styles.wrapper, { [styles.reverse]: props.imagePosition === 'left' })}>
          <div className={classnames(styles.contentBlock, props.hasRTL ? styles.rtl : '')}>
            <ContentBlock
              title={props.title}
              titleClass="is-2"
              content={props.intro ?? undefined}
              links={props.links ?? undefined}
              button={props.button ?? undefined}
            />
          </div>
          <div className={classnames(styles.image)}>
             <Image image={props.mandatory_image} style={imageStyle} loading="lazy" />
          </div>
        </div>
      </div>
    </div>
  );
};
